import { ProjectService } from '#services/api';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, tap } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit {
  constructor(private translate: TranslateService, private projectService: ProjectService) {
 
  }

  ngOnInit(): void {
    this.translate.addLangs(['en', 'ru', 'kaz']);
    this.translate.setDefaultLang('en');
    const lang = localStorage.getItem('language');
    if (lang) {
      this.translate.use(lang);
    } else {
      this.translate.use('en');
    }
  }

  deleteNotification(e:any){
    if(e.message.id && e.message.projectid && e.message.schedulerId){
    this.projectService.deleteSyncNotification(e.message.id, e.message.projectid, e.message.schedulerId).subscribe({
      next:(res) => console.log(res),
      error(err) {
        console.error(err);
      },
    })
    }
  }

}
